import React from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import { useCreateRic, validationSchemaRic } from "./Services";
import { Ric } from "./types";
import { FormField } from "../../common/FormField";
import {
  useFieldsRic_1,
  useFieldsRic_2,
  useFieldsRic_3,
  useFieldsRic_4,
} from "./FormRic";

interface AddRicProps {
  open: boolean;
  onClose: () => void;
  defaultDate?: Date | null;
}

const AddRic: React.FC<AddRicProps> = ({ open, onClose, defaultDate }) => {
  type RicForm = Yup.InferType<typeof validationSchemaRic>;

  const { control, handleSubmit, setValue, reset } = useForm<RicForm>({
    resolver: yupResolver(validationSchemaRic),
    defaultValues: {
      dataric: defaultDate ?? new Date(),
      ditta: 2,
      idprog: "",
      coddip: "",
      titolo: "",
      note: "",
      canale: "",
      codcli: null,
      refcliente: "",
      idcatric: 6,
      idstatoric: 1,
      idlivelloric: 2,
      dataapertura: new Date(),
      datachiusura: null,
      datavalutazione: null,
      valutatore: "",
    },
  });

  const f1 = useFieldsRic_1();
  const f2 = useFieldsRic_2();
  const f3 = useFieldsRic_3();
  const f4 = useFieldsRic_4();

  const { mutateAsync, isPending } = useCreateRic();

  const handleClose = () => {
    reset();
    onClose();
  };

  const onSubmit: SubmitHandler<RicForm> = async data => {
    await mutateAsync(data as Ric);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h6">Nuova Richiesta</Typography>
      </DialogTitle>

      <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack direction="row" spacing={1}>
            {f1.map(f => (
              <FormField key={String(f.name)} control={control} field={f as any} />
            ))}
          </Stack>

          <Stack direction="row" spacing={1}>
            {f2.map(f => (
              <FormField key={String(f.name)} control={control} field={f as any} />
            ))}
          </Stack>

          <Stack direction="row" spacing={1}>
            {f3.map(f => (
              <FormField key={String(f.name)} control={control} field={f as any} />
            ))}
          </Stack>

          <Stack direction="row" spacing={1}>
            {f4.map(f => (
              <FormField key={String(f.name)} control={control} field={f as any} />
            ))}
          </Stack>

          <Stack direction="row" justifyContent="flex-end" spacing={2}>
            <Button onClick={handleClose} color="error">
              Annulla
            </Button>
            <Button type="submit" variant="contained" disabled={isPending}>
              {isPending ? "Salvando…" : "Salva"}
            </Button>
          </Stack>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddRic;
